<div  class="dd-v-spec-protection-products-detail">
  <dd-vehicle-detail-header [vehicleDetails]="vehicle" [sharedData]="shared"></dd-vehicle-detail-header>
  <dd-app-menu id="divToScroll"></dd-app-menu>
  <div class="dd-content-margin" id="backid">

    <span style="display: flex;">
    <i><label id="backicon" (click)="navigateToProducts()" class="arrow-left"></label></i>
    <div id="backlabel" (click)="navigateToProducts()">View Products</div>
  </span>
  <button class="download-button"><a href="{{browcherURL}}" target="_blank"><label style="color: white !important; font-family: ToyotaType-Bold;" ><b>Brochure</b></label><i class="icon-download"></i></a></button>
  </div>
  <dd-page-title [title]="selectedproduct.displayName"></dd-page-title>
  <div style="margin-top: 20px;" fxLayout="column" fxLayoutGap="10px">


    <div class="dd-content-margin">
      <div class="dd-products-container">
        <div class="dd-pp-detail-container">
          <div *ngIf="transactionType!='Cash'"  class="dd-para-title">
            <span class="dd-title-text"> {{actualPlanId}}</span>
          </div>
          <div *ngIf="transactionType=='Cash'"  style="margin-top: 20px;" class="dd-para-title">
            <span class="dd-title-text"> {{actualPlanId}}</span>
          </div>
          <div  class="dd-base-model">
            <div class="dd-opt-header-text">Deductible</div>
            <div class="dd-opt-value">{{selectedproduct.deductible  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div class="dd-base-model">
            <div class="dd-opt-header-text">Term</div>
            <div class="dd-opt-value">{{selectedproduct.timeMileage}}</div>
          </div>
          <div class="dd-line dd-products-line"></div>
          <div *ngIf="transactionType!='Cash'" class="dd-base-model">
            <div class="dd-opt-header-text">Total Cost</div>
            <div class="dd-opt-value">{{selectedproduct.customerPrice  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div *ngIf="transactionType!='Cash'" class="dd-line dd-products-line"></div>
          <div *ngIf="transactionType!='Cash'" class="dd-base-model">
            <div class="dd-totalcost-total-red">Monthly Cost</div>
            <div class="dd-totalcost-total-red-value">{{selectedproduct.monthlyPayment  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div *ngIf="transactionType!='Cash'" class="dd-line dd-products-line"></div>
          <div *ngIf="transactionType=='Cash'" class="dd-base-model">
            <div class="dd-totalcost-total-red">Total Cost</div>
            <div class="dd-totalcost-total-red-value">{{selectedproduct.customerPrice  | currency:'USD':'symbol':'1.2-2'}}</div>
          </div>
          <div *ngIf="transactionType=='Cash'" class="dd-line dd-products-line"></div>
        </div>
        <div class="dd-pp-detail-container">
          <!-- <video controls style="width:100%; max-height: 230px;" poster="../../../../assets/images/video-thumb.png">
          
            <source src="295a1923121e47dba5bb0df4c0478bea"
              type="video/mp4">
            Your browser does not support the video tag.
          </video> -->
          <img (click)="playVideo()"  style="width:100%; max-height: 230px; margin-top: 25px;"  src="../../../../assets/images/video-thumb.png">
        </div>

      </div>
    </div>
    <div class="protectionPlansheader">
      <div class="header-container">
        <ul class="header-container-item protectionul">
          <li class="protectionli" *ngFor="let plan of allPlans" [ngClass]="(plan.id == selectedproduct.planId )?'active':''" (click)="selectTab(plan.id)">
            {{plan.displayName}}
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="overViewContent.length>0" fxLayout="column" class="dd-standard-equib-container" >
      <div fxLayout="column" class="dd-content-margin">
        <div class="dd-para-title">
          <span class="dd-title-text">Overview</span>
        </div>
        <!-- <div class="dd-standard-equib-title">
          <label class="dd-para-head">FEATURES</label>
        </div> -->
        <div class="dd-pp"></div>
        <label [innerHTML]="overViewContent"></label>

      </div>
    </div>

    <div *ngIf="elegibliltyContent.length>0" fxLayout="column" class="dd-standard-equib-container">
      <div fxLayout="column" class="dd-content-margin">
        <div class="dd-para-title">
          <span class="dd-title-text">Vehicle Eligibility</span>
        </div>
        <!-- <div class="dd-standard-equib-title">
          <label class="dd-para-head">FEATURES</label>
        </div> -->
        <div class="dd-pp"></div>
        <label [innerHTML]="elegibliltyContent"></label>
        <!-- <label>Vehicles are eligible for new vehicle Vehicle Service Agreements (VSAs) up to 3 years or 36,000 total
          vehicle miles, whichever comes first. Coverage is effective from date of first use as a new vehicle and zero
          miles.4 Coverage expires at maximum time or mileage of the selected plan, whichever comes first. </label> -->

      </div>
    </div>
    <div  *ngIf="benifitsContent.length>0" fxLayout="column" class="dd-standard-equib-container" >
      <div fxLayout="column" class="dd-content-margin">
        <div class="dd-para-title">
          <span class="dd-title-text">Benefits</span>
        </div>
        <!-- <div class="dd-standard-equib-title">
          <label class="dd-para-head">FEATURES</label>
        </div> -->
        <div class="dd-pp"></div>
        <label [innerHTML]= "benifitsContent"></label>
    

      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="dd-content-margin"
    style="padding-bottom: 3%;padding-top: 2%;">
    <div class="dd-disclaimer">
      <label [innerHTML]= "disclaimer"></label>
    </div>
  </div>
  </div>
  <rti-modal-dialog
*onActionClick="[handleVideoEvent]"
[actions]="dialogActions"> 
<div class="rti-protection-product-detail-header" header-text></div>  
  <!-- <div id="videoThumbnail"></div> -->
  <video class="rti-protection-product-detail-video" controls autoplay>
    <source src="{{videoURL}}" >
    Your browser does not support HTML video.
  </video>
</rti-modal-dialog>
</div>
